import holidays from './hebrew-holidays-until-2050.json';

const holidaysMap = new Set<number>(holidays);
const HoursRegex = /^(\d{2}):(\d{2})-(\d{2}):(\d{2})$/;

export const isOpen = (_hours: string, _hours_weekend: string, checkHolidays = true) => {
  const timeIsrael = new Date().toLocaleString('en-US', {timeZone: 'Asia/Jerusalem'});
  const now = new Date(timeIsrael);
  const day = now.getDay();
  let isWeekend = false;
  const fullDaysSinceEpoch = Math.floor(now.valueOf() / 8.64e7);
  if (day === 6) return false; // שבת
  if (checkHolidays && holidaysMap.has(fullDaysSinceEpoch)) return false; // חג
  if (day === 5) isWeekend = true; // שישי
  if (checkHolidays && holidaysMap.has(fullDaysSinceEpoch + 1)) isWeekend = true; // ערב חג
  const hours = isWeekend ? _hours_weekend : _hours;
  const seconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
  const match = hours.match(HoursRegex);
  if (match) {
    const min = parseInt(match[1]) * 3600 + parseInt(match[2]) * 60;
    const max = parseInt(match[3]) * 3600 + parseInt(match[4]) * 60;
    return seconds >= min && seconds <= max;
  } else {
    return false;
  }
};
